import { Tools } from '@otp/icons';
import { ActionsColumn, Card, Chip, Typography } from '@otp/ui';

export type Tool = {
  name: string;
  link: string;
  description?: string;
  tags?: string[];
};

type CardProps = {
  tool: Tool;
};

export const ToolCard = ({
  tool: { name, link, description, tags },
}: CardProps) => {
  const navigate = () => {
    window.open(link, '_blank');
  };

  return (
    <Card
      className="flex flex-col h-auto w-auto"
      isLink={true}
      onClick={navigate}
    >
      <div className="flex items-center gap-2 mb-3">
        <ActionsColumn icons={[{ icon: <Tools />, onClick: navigate }]} />
        <Typography variant="subtitle1">{name}</Typography>
      </div>

      {description && (
        <Typography variant="subtitle2" className="text-primary-500">
          {description}
        </Typography>
      )}

      {tags && (
        <div className="flex gap-1 mt-3">
          {tags.map((tag) => (
            <Chip key={tag} label={tag} />
          ))}
        </div>
      )}
    </Card>
  );
};
